import { Link, useLocation } from "react-router";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import MobileNav from "./MobileNav";
import LanguageSelector from "../LanguageSelector";

const Header = () => {
  const location = useLocation();
  const { t } = useTranslation();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const navLinks = [
    { name: t("header.home"), href: "/#" },
    { name: t("header.aboutUs"), href: "/#" },
    { name: t("header.forDentists"), href: "/#" },
    { name: t("header.joinUs"), href: "/#" },
  ];

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  return (
    <div className="relative">
      <header className="fixed top-4 md:top-6 left-0 right-0 z-40 rounded-2xl">
        <div className="container-custom bg-[#0000000D] backdrop-blur-[54px] rounded-2xl mx-0">
          <div className="flex items-center justify-between py-4">
            <Link to="/">
              <img
                src="/assets/logo.svg"
                alt="DentFinder"
                className="h-8 w-auto"
              />
            </Link>

            <nav className="hidden md:flex items-center space-x-8">
              {navLinks.map((link, index) => (
                <div
                  key={index}
                  className="flex items-center space-x-2 group cursor-pointer hover:text-white transition-colors relative"
                >
                  <Link
                    to={link.href}
                    className={`text-sm font-medium transition-colors ${
                      location.pathname === link.href
                        ? "text-white font-[700]"
                        : "text-white hover:text-white"
                    }`}
                  >
                    {link.name}
                  </Link>
                </div>
              ))}
            </nav>

            <div className="flex items-center space-x-4">
              {/* Language Selector */}
              <div className="hidden md:block">
                <LanguageSelector />
              </div>

              <Link to="/get-started" className="hidden md:flex btn-primary">
                {t("header.getStarted")}
              </Link>

              <button
                onClick={toggleMobileMenu}
                className="md:hidden p-2 text-white relative z-[60]"
              >
                <svg
                  className={`w-6 h-6 transition-transform duration-300 ${
                    isMobileMenuOpen ? "rotate-90" : ""
                  }`}
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  {isMobileMenuOpen ? (
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M6 18L18 6M6 6l12 12"
                    />
                  ) : (
                    <svg
                      width="20"
                      height="14"
                      viewBox="0 0 20 14"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M1 7L19 7M1 1H19M1 13H13"
                        stroke="white"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                  )}
                </svg>
              </button>
            </div>
          </div>
        </div>
      </header>

      <MobileNav
        isOpen={isMobileMenuOpen}
        onClose={toggleMobileMenu}
        navLinks={navLinks}
      />
    </div>
  );
};

export default Header;
